import { render } from "./IconTrekTorque.vue?vue&type=template&id=4d18db22"
import script from "./IconTrekTorque.vue?vue&type=script&lang=js"
export * from "./IconTrekTorque.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__